module.exports = function isObject(arg) {
  var type = typeof arg;
  return Boolean(arg) && (type === 'object' || type === 'function');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stamp/is/object.js
// module id = 24
// module chunks = 0